import Vue from "vue";
import VueRouter from "vue-router";
import Meeting from "@/components/Meeting";
import Home from "@/pages/Home";
import SignUp from "@/pages/SignUp";
import AuthCallback from "@/pages/AuthCallback";
import VerifyEmail from "@/pages/VerifyEmail";
import LogiAuthorization from "@/pages/LogiAuthorization";
import Features from "@/pages/Features";
import e404 from "@/pages/e404";
import PasswordReset from "@/pages/PasswordReset";
import Pricing from "@/pages/Pricing";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import userSubscription from "@/pages/userSubscription";
import EnterYourName from "@/pages/EnterYourName";
import userProfile from "@/pages/userProfile";
import userPassword from "@/pages/userPassword";
import Dashboard from "@/pages/Dashboard";
import userRooms from "@/pages/userRooms";
import Recordings from "@/pages/Recordings";
import userPlan from "@/pages/userPlan";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import {authGuard} from "../auth/authGuard";
import HandleAuthAction from "../pages/HandleAuthAction";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home,
        // This should work in most cases where authentication was done successfully
        // If not the case the user will be required to authenticate
        beforeEnter: (to, from, next) => {
            if (from.path === "/" && localStorage.getItem("isAuthenticated")) {
                next("/user_rooms");
            } else {
                next();
            }
        },
    },
    {
        path: "/auth/callback",
        name: "AuthCallback",
        component: AuthCallback,
    },
    {
        path: "/auth/sign-up",
        name: "SignUp",
        component: SignUp,
    },
    {
        path: "/auth/password-reset",
        name: "PasswordReset",
        component: PasswordReset,
    },
    {
        path: "/auth/verify-email",
        name: "VerifyEmail",
        component: VerifyEmail,
    },
    {
        path: "/room/:nickname",
        name: "Meeting",
        props: true,
        component: Meeting,
    },
    {
        path: "/features",
        name: "Features",
        component: Features,
    },
    {
        path: "/forgot",
        name: "Forgot password",
        component: PasswordReset,
    },
    {
        path: "/auth/login",
        name: "Login",
        component: LogiAuthorization,
    },
    {
        path: "/pricing",
        name: "Pricing",
        component: Pricing,
    },
    {
        path: "/privacy",
        name: "Privacy",
        component: Privacy,
    },
    {
        path: "/sign_up",
        name: "Sign up",
        component: SignUp,
    },
    {
        path: "/terms",
        name: "Terms",
        component: Terms,
    },
    {
        path: "/user_rooms",
        name: "User rooms",
        component: userRooms,
        beforeEnter: authGuard,
    },
    {
        path: "/user_subscriptions",
        name: "User subscriptions",
        component: userSubscription,
        beforeEnter: authGuard,
    },
    {
        path: "/user_profile",
        name: "User profile",
        component: userProfile,
        beforeEnter: authGuard,
    },
    {
        path: "/user_pass",
        name: "User change password",
        component: userPassword,
        beforeEnter: authGuard,
    },
    {
        path: "/recordings/:meetingId",
        name: "Room recordings",
        component: Recordings,
        props: true
    },
    {
        path: "/user_plan",
        name: "User Plan",
        component: userPlan,
        beforeEnter: authGuard,
    },
    {
        path: "/checkout/success",
        name: "Checkout Success",
        component: CheckoutSuccess,
    },
    {
        path: "/dashboard",
        name: "Dashboard",
        component: Dashboard,
    },
    {
        path: "/enter_name",
        name: "Enter_your_name",
        component: EnterYourName,
    },
    {
        path: "/auth/handle-action",
        name: "handle-auth-action",
        component: HandleAuthAction,
        props: route => ({
            mode: route.query.mode,
            code: route.query.oobCode,
            ...(route.query.successToken && {successToken: route.query.successToken})
        })
    },
    {
        path: "/:catchAll(.*)",
        name: "e404",
        component: e404,
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    scrollBehavior() {
        return {x: 0, y: 0};
    },
});

export default router;
